import * as mutation_types from '../mutation-types'

const state = {
    benchmarkFreemiumEnabled: false,
    hasActiveMetricsFreemiumPopup: false,
};

const mutations = {
    [mutation_types.SET_ACTIVE_METRICS_FREEMIUM_INFO]: async (state, bool) => {
        Vue.set(state, "hasActiveMetricsFreemiumPopup", bool);
    },
    [mutation_types.SET_BENCHMARK_FREEMIUM_ENABLED]: async (state, bool) => {
        Vue.set(state, "benchmarkFreemiumEnabled", bool);
    },
};

const getters = {
    GET_ACTIVE_METRICS_FREEMIUM_INFO: (state) => state.hasActiveMetricsFreemiumPopup,
    GET_BENCHMARK_FREEMIUM_ENABLED: (state) => state.benchmarkFreemiumEnabled,
};

export default {
    state,
    mutations,
    getters
}